export default __webpack_public_path__ + "static/media/Logo mhdent.aa4fa8af.png";